import { createBrowserRouter, Route } from "react-router-dom";
// import RequireAuth from "./ProtectedRoute";
import Home from "./home/home.component";
import EventsDirectory from "./eventsDirectory/eventDirectory.component";
import EventDetails from "./eventDetails/eventDetails.component";
import Programme from "./programme/programme.component";
import Admin from "./Admin/admin.component";
import DeleteModal from "../components/customForm/DestinationDeleteModal";
import DestinationDeleteModal from "../components/customForm/DestinationDeleteModal";
import AdminAdventure from "./Admin/admin.adventure";
import AdminProgramme from "./Admin/admin.programme";
import AdminComponent from "../views/Admin";
import AdminDestinations from "../views/Admin/Destinations";
import AdminAdventures from "../views/Admin/Adventures";
import AdminProgrammes from "../views/Admin/Programmes";
import RequireAuth from "./ProtectedRoute";
import LoginComponent from "../views/Admin/Login";
import HomeComponent from "../views/Home";
import DestinatioDetail from "../views/Destination/detail";
import DestinationList from "../views/Destination";
import EventList from "../views/Event";
import EventDetail from "../views/Event/detail";
import ProgrammeList from "../views/Programmes";
import ProgrammeDetail from "../views/Programmes/detail";
import AboutUs from "../views/AboutUs";


const MainRouter = createBrowserRouter([
  //   {
  //     path: "/",
  //     element: (
  //       <RequireAuth>
  //         <Dashboard />
  //       </RequireAuth>
  //     ),
  //   },

  {
    path: "login",
    element: <LoginComponent />,
  },
  {
    path: "/",
    element: <HomeComponent />,
  },
  {
    path: "/home2",
    element: <Home />,
  },

  {
    path: "/about-us",
    element: <AboutUs />,
  },

  {
    path: "events2",
    element: <EventsDirectory />,
    children: [
      {
        path: "details/:id",
        element: <EventDetails />,
      },
      {
        path: "programme",
        element: <Programme />,
      },
    ],
  },

  {
    path: "country/destinations/:country",
    element: <DestinationList />,
  },

  {
    path: "events",
    element: <EventList />,
  },

  {
    path: "programmes",
    element: <ProgrammeList />,
  },

  {
    path: "programmes/:programmeId",
    element: <ProgrammeDetail />,
  },

  {
    path: "events/:eventId",
    element: <EventDetail />,
  },

  {
    path: "destinations/:destinationId",
    element: <DestinatioDetail />,
  },
  {
    path: "admin2",
    element: <Admin />,
    children: [],
  },

  {
    path: "admin2/adventure",
    element: <AdminAdventure />,
  },

  {
    path: "admin2/programme",
    element: <AdminProgramme />,
  },

  {
    path: "admin",
    element: (
      <RequireAuth>
        <AdminComponent />
      </RequireAuth>
    ),
    children: [],
  },

  {
    path: "admin/destinations",
    element: (
      <RequireAuth>
        <AdminDestinations />
      </RequireAuth>
    ),
  },

  {
    path: "admin/adventures",
    element: (
      <RequireAuth>
        <AdminAdventures />
      </RequireAuth>
    ),
  },

  {
    path: "admin/programmes",
    element: (
      <RequireAuth>
        <AdminProgrammes />
      </RequireAuth>
    ),
  },
]);

export default MainRouter;
